// extracted by mini-css-extract-plugin
export var beFooter = "universalFooter-module--beFooter--43e35";
export var charcoal = "universalFooter-module--charcoal--7aba0";
export var cotton = "universalFooter-module--cotton--adf21";
export var desktopList = "universalFooter-module--desktopList--48d1d";
export var footer = "universalFooter-module--footer--89b2b";
export var footerNav = "universalFooter-module--footerNav--af7dd";
export var fullWidth = "universalFooter-module--fullWidth--baecc";
export var grid = "universalFooter-module--grid--92d2d";
export var languageSelector = "universalFooter-module--languageSelector--8104b";
export var legal = "universalFooter-module--legal--8b2ef";
export var legalLink = "universalFooter-module--legalLink--20909";
export var legalNavigation = "universalFooter-module--legalNavigation--4c431";
export var logo = "universalFooter-module--logo--08f56";
export var menuColumnListItem = "universalFooter-module--menuColumnListItem--e4cf3";
export var menuColumnListItems = "universalFooter-module--menuColumnListItems--9dd81";
export var menuContainer = "universalFooter-module--menuContainer--e97ff";
export var minimal = "universalFooter-module--minimal--b82cf";
export var mobileList = "universalFooter-module--mobileList--0c867";
export var privacy = "universalFooter-module--privacy--d9430";
export var social = "universalFooter-module--social--76386";
export var socialIconText = "universalFooter-module--socialIconText--a14b4";
export var socialLink = "universalFooter-module--socialLink--46bb3";
export var tagline = "universalFooter-module--tagline--d6d97";